module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.438a9b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/title-banner1-type1.png
// module id = IPqq
// module chunks = 1